module.exports = __webpack_public_path__ + "img/2-1.6db524fa.png";